import request from "@/utils/request";
/***************综合信息查询*****************/
// 会员申请信息查询
function selectGroupNameListByYear(params) {
  return request({
    url: "/sys/techGroup/selectGroupNameListByYear",
    method: "post",
    params,
  });
}

// 根据省份编号获取下辖市
function getPrefecture(data) {
  return request({
    url: `/area/diqu/${data.provinceId}`,
    method: "get",
  });
}

// 获取下拉序列
export function getDownIndex(data) {
  return request({
    url: `/admin/select/${data.chooseType}/${data.workId}`,
    method: "get",
  });
}

// 添加参赛人员 下拉序列
export function getMatchManIndex(data) {
  return request({
    url: `/admin/sign/${data.chooseType}/${data.signId}`,
    method: "get",
  });
}
// 获取评定小组
export function getListPullDownProjGroup(params) {
  return request({
    url: `/proj/group/listPullDownProjGroup`,
    method: "post",
    params,
  });
}

/**
 * 终评分组绑定组下拉
 * @param {*} data
 * @returns
 */
export function getProjTerminalGroupDown(data) {
  return request({
    url: `/proj/terminal/group/down/${data.awardYear}`,
    method: "get",
  });
}

export function getRoels() {
  return request({
    url: `/chzz-role/option`,
    method: "post",
    data: {
      "roleId": 0,
      "roleIds": [],
      "roleName": "",
      "roleType": 0
    }
  });
}


export default {
  selectGroupNameListByYear,
  getPrefecture,
  getListPullDownProjGroup,
  getProjTerminalGroupDown,
  getRoels,
};
